import { createFeatureSelector } from "@ngrx/store";

import { FeatureState } from "../reducers";

export const selectFeatureState =
  createFeatureSelector<FeatureState>("featureState");
